<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="neg-escopo neg-modal">
      <q-card-section class="neg-modal__titulo">
        Configurações do módulo
        <div class="neg-sub">Dia do repasse do banco e o destino da comissão no financeiro</div>
      </q-card-section>

      <q-card-section class="neg-modal__corpo">
        <q-input
          :model-value="opcoes.negocios_dia_repasse"
          @update:model-value="opcoes.negocios_dia_repasse = $numero($event)"
          dense
          type="number"
          min="1"
          max="28"
          label="Dia do repasse"
          hint="O dia do mês seguinte em que o banco paga, conforme o seu contrato"
          :error="Boolean(erros.negocios_dia_repasse)"
          :error-message="primeiroErro('negocios_dia_repasse')"
        />

        <q-toggle
          v-model="opcoes.negocios_gerar_receita"
          label="A comissão vira receita no financeiro"
        />
        <div class="neg-sub">
          Com isto ligado, dar baixa num repasse cria uma receita consolidada do lote.
        </div>

        <q-select
          v-model="opcoes.negocios_categoria_id"
          dense
          clearable
          emit-value
          map-options
          label="Categoria da receita"
          option-value="id"
          option-label="titulo"
          option-disable="disable"
          :options="planoContas"
          :disable="!opcoes.negocios_gerar_receita"
          :error="Boolean(erros.negocios_categoria_id)"
          :error-message="primeiroErro('negocios_categoria_id')"
        />

        <q-select
          v-model="opcoes.negocios_conta_id"
          dense
          clearable
          emit-value
          map-options
          label="Conta de destino"
          option-value="id"
          option-label="titulo"
          :options="contas"
          :disable="!opcoes.negocios_gerar_receita"
        />

        <q-select
          v-model="cadastroPagador"
          use-input
          fill-input
          hide-selected
          dense
          clearable
          input-debounce="300"
          label="Cadastro do banco pagador"
          hint="Opcional. Quem aparece como pagador da receita"
          option-label="label"
          :options="cadastrosEncontrados"
          :disable="!opcoes.negocios_gerar_receita"
          @filter="buscarCadastro"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps label="Cancelar" @click="$emit('update:modelValue', false)" />
        <q-btn
          unelevated
          no-caps
          color="primary"
          label="Salvar configurações"
          :loading="salvando"
          @click="salvar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-modal-configuracao",

  emits: ["update:modelValue"],
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opcoes: {},
      cadastroPagador: null,
      cadastrosEncontrados: [],
      salvando: false,
      erros: {}
    };
  },
  computed: {
    ...mapGetters(["negociosConfig", "planoContas", "contas"])
  },
  watch: {
    modelValue(aberto) {
      if (!aberto) {
        return;
      }

      this.erros = {};
      this.opcoes = {
        negocios_dia_repasse: Number(this.negociosConfig.negocios_dia_repasse || 10),
        negocios_gerar_receita: this.negociosConfig.negocios_gerar_receita === true,
        negocios_categoria_id: this.negociosConfig.negocios_categoria_id || null,
        negocios_conta_id: this.negociosConfig.negocios_conta_id || null,
        negocios_cadastro_id: this.negociosConfig.negocios_cadastro_id || null
      };

      this.cadastroPagador = null;
      this.cadastrosEncontrados = [];

      this.$store.dispatch("planoContas", "C");
      this.$store.dispatch("contas");
      this.carregarPagador();
    }
  },
  methods: {
    carregarPagador() {
      const id = this.opcoes.negocios_cadastro_id;

      if (!id) {
        return;
      }

      this.$store.dispatch("buscarNegociosCadastro", id).then(resposta => {
        if (!resposta || !resposta.success || !resposta.cadastro) {
          return;
        }

        this.cadastroPagador = {
          id: resposta.cadastro.id,
          label: resposta.cadastro.nome
        };
      });
    },
    buscarCadastro(termo, atualizar, abortar) {
      if (!termo) {
        return abortar();
      }

      this.$store.dispatch("buscarNegociosCadastros", termo).then(cadastros => {
        atualizar(() => {
          this.cadastrosEncontrados = cadastros;
        });
      });
    },
    salvar() {
      this.salvando = true;
      this.erros = {};

      const opcoes = {
        ...this.opcoes,
        negocios_cadastro_id: this.cadastroPagador ? this.cadastroPagador.id : null
      };

      this.$store.dispatch("salvarNegociosConfig", opcoes).then(resposta => {
        this.salvando = false;

        if (!resposta.success) {
          this.erros = resposta.errors || {};
        }

        this.avisar(resposta.message, resposta.success ? "green" : "orange");

        if (resposta.success) {
          this.$emit("update:modelValue", false);
        }
      });
    }
  }
};
</script>
